module.exports = __webpack_public_path__ + "static/media/pc-icon-weibo.0c8b78f5.svg";